import { TOGGLE_MENU_DISPLAY, UPDATE_PROFILE_DETAIL, INITIAL_PROFILE_DETAIL } from "../actionTypes";

const showMenuDisplayAction = () => ({
	type: TOGGLE_MENU_DISPLAY,
	menuDisplay: true
})

const hideMenuDisplayAction = () => ({
	type: TOGGLE_MENU_DISPLAY,
	menuDisplay: false
})

const updateProfileDetailAction = (d) => ({
	type: UPDATE_PROFILE_DETAIL,
	profileDetail: d
})

const initialProfileAction = () => ({
	type: INITIAL_PROFILE_DETAIL,
})

export {
	showMenuDisplayAction,
	hideMenuDisplayAction,
	updateProfileDetailAction,
	initialProfileAction
}


// WEBPACK FOOTER //
// ./src/store/actions/headerBar.js